import { render } from "./onlineorderdetails.vue?vue&type=template&id=24635a87"
import script from "./onlineorderdetails.vue?vue&type=script&lang=js"
export * from "./onlineorderdetails.vue?vue&type=script&lang=js"

import "./onlineorderdetails.vue?vue&type=style&index=0&id=24635a87&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__